var parseVideoUrl = function parseVideoUrl() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (text === '') return text;
  var groups = text.match(/v\/([a-zA-Z0-9_-]+)&?/);
  var id = (groups == null ? void 0 : groups.length) ? groups[1] : null;
  if (!id) return '';
  return "https://www.youtube.com/embed/".concat(id);
};
export default parseVideoUrl;